module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ArticleListView.js"));
	}, "FindingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FindingView!./src/pages/Learn/ArticleList/ArticleListView.js
// module id = 2238
// module chunks = 367